// Free email providers' domains (Gmail, Yahoo…). Mail "from" these sent through
// us fails the provider's own checks and lands in spam. Keep in step with
// internal/util/emaildomain on the server.
const FREE_MAIL = new Set(`
  gmail.com googlemail.com
  yahoo.com yahoo.co.uk yahoo.ca yahoo.com.au yahoo.fr yahoo.de ymail.com rocketmail.com
  outlook.com hotmail.com hotmail.co.uk live.com msn.com
  icloud.com me.com mac.com
  aol.com proton.me protonmail.com pm.me
  gmx.com gmx.net gmx.de mail.com zoho.com yandex.com yandex.ru
  comcast.net att.net sbcglobal.net verizon.net`.trim().split(/\s+/));

// isFreeMailAddress: is this address on a free email provider?
export function isFreeMailAddress(email) {
  const at = String(email || "").lastIndexOf("@");
  if (at < 0) return false;
  return FREE_MAIL.has(String(email).slice(at + 1).trim().toLowerCase().replace(/\.$/, ""));
}
